
import EnvironmentList from "./EnvironmentList";


const Environments = () => {
    return (
        <div className="Environments">
            <h1>Environments</h1>
            <EnvironmentList />
        </div>
    );
};
export default Environments;
